<template>
  <v-container>
    <v-row>
      <v-col>
        <div class="box-header">
          <v-btn class="secondary" data-toggle="modal" :data-target="createModalIdDisplay">
            Create new
          </v-btn>
          <v-btn small class="ml-2 secondary--text" @click.stop="paginate(1)">
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
        </div>
        <div class="box-body">
          <v-card>
            <v-card-text>
              <v-layout wrap mb-2 style="justify-content:right">
                <v-flex xs12 md4>
                  <v-text-field
                    class="pt-0"
                    v-model="filter"
                    append-icon="search"
                    label="Search"
                    single-line
                    hide-details
                    @keyup.enter="paginate(1)"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-data-table
                :headers="fields"
                :items="items"
                :options.sync="pagination"
                :server-items-length="totalRows"
              >
                <template v-slot:body="{items}">
                  <tbody>
                    <tr v-for="item in items" :key="item.id">
                      <td>{{item.name}}</td>
                      <td>{{item.address}}</td>
                      <td>{{item.website}}</td>
                      <td>{{item.phoneNumber}}</td>
                      <td>
                        <v-btn color="red" class="ims-action" small @click.stop="deleteCompany(item.id)">
                          <v-icon style="color:#fff" small>mdi-delete</v-icon>
                        </v-btn>
                        <v-btn small class="ims-action primary ml-1" data-toggle="modal" :data-target="editModalIdDisplay" @click="getCompanyDataToEdit(item.id)">
                          <v-icon small>mdi-pencil</v-icon>
                        </v-btn>
                        <v-btn small color="info" class="ims-action ml-1" data-toggle="modal" :data-target="viewModalIdDisplay" @click="getCompanyDataToView(item.id)">
                          <v-icon style="color:#fff" small>mdi-eye</v-icon>
                        </v-btn>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </div>
      </v-col>
    </v-row>
    <create-company-modal :modalId="createModalId" @createCompany="createCompany" />
    <edit-company-modal :modalId="editModalId" :companyData="editCompanyData" @editCompany="editCompany" />
    <view-company-modal :modalId="viewModalId" :companyData="viewCompanyData" />
  </v-container>
</template>

<script>
import moment from 'moment'
import companyAPIs from './companyAPIs'
import CreateCompanyModal from './CreateCompanyModal'
import EditCompanyModal from './EditCompanyModal'
import ViewCompanyModal from './ViewCompanyModal'

export default {
  name: 'Company',
  components: {
    CreateCompanyModal,
    EditCompanyModal,
    ViewCompanyModal
  },
  data() {
    return {
      createModalId: 'create_company_modal',
      editModalId: 'edit_company_modal',
      viewModalId: 'view_company_modal',
      editCompanyData: null,
      viewCompanyData: null,
      sortBy: 'name',
      sortDesc: false,
      fields: [
        { text: 'Name', value: 'name' },
        { text: 'Address', value: 'address' },
        { text: 'Website', value: 'website' },
        { text: 'Phone Number', value: 'phoneNumber' },
        { text: 'Actions', value: 'actions', sortable: false }
      ],
      items: [],
      pagination: {
        page: 1,
        itemsPerPage: 15
      },
      lastUpdate: null,
      totalRows: 0,
      currentPage: 1,
      perPage: 15,
      filter: ''
    }
  },
  computed: {
    updatedOn: function() {
      return moment(this.lastUpdate).fromNow()
    },
    createModalIdDisplay: function() {
      return '#' + this.createModalId
    },
    editModalIdDisplay: function() {
      return '#' + this.editModalId
    },
    viewModalIdDisplay: function() {
      return '#' + this.viewModalId
    }
  },
  watch: {
    pagination(newVal) {
      this.paginate(newVal.page)
    }
  },
  methods: {
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    updateItems(response) {
      this.items = response.companies
      this.totalRows = response.totalCompanies
    },
    paginate(page = 1) {
      this.currentPage = page
      companyAPIs
        .paginate(page, this.perPage, this.filter)
        .then(response => {
          this.updateItems(response)
        })
        .catch(error => {
          console.log('error', error)
        })
    },
    createCompany(companyData) {
      this.paginate(1)
    },
    deleteCompany(companyID) {
      this.$swal({
        title: 'Deleting',
        text: 'Are you sure you want to delete the company?',
        type: 'error',
        showCancelButton: true,
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
        showCloseButton: true,
        showLoaderOnConfirm: true,
        preConfirm: () => {
          return companyAPIs
            .deleteCompany(companyID)
            .then(response => {
              return response
            })
            .catch(error => {
              console.log('error', error)
              this.$swal.showValidationError('Something went wrong! Please try again or contact our admin')
            })
        },
        allowOutsideClick: () => !this.$swal.isLoading()
      }).then(result => {
        if (result.value) {
          this.items = this.items.filter(company => company.id !== companyID)
          this.$swal({
            title: 'Deleted',
            text: 'The company has been deleted successfully',
            type: 'success'
          })
        }
      })
    },
    getCompanyDataToEdit(companyID) {
      companyAPIs
        .getCompany(companyID)
        .then(response => {
          this.editCompanyData = response
        })
        .catch(error => {
          console.log('error', error)
        })
    },
    getCompanyDataToView(companyID) {
      companyAPIs
        .getCompany(companyID)
        .then(response => {
          this.viewCompanyData = response
        })
        .catch(error => {
          console.log('error', error)
        })
    },
    editCompany(companyData) {
      var selectedIndex = -1

      this.items.forEach(function(company, index) {
        if (company.id === companyData.id) {
          selectedIndex = index
          return
        }
      })

      if (selectedIndex !== -1) {
        this.$set(this.items, selectedIndex, companyData)
      }
      console.log('Company edited')
    }
  },
  created() {
    this.paginate(1)
  }
}
</script>

<style scoped>
.ims-action {
  height: 35px !important;
}
</style>



// WEBPACK FOOTER //
// index.vue?0e3c9b7c